import { isPresent } from 'utils/isPresent';

import url from 'components/url';

import { VOICE_DEVICE_HEIGHT, VOICE_DEVICE_WIDTH } from '../../Voice/voiceConstants';

export const JOBS_TYPE = 'Job';
export const ESTIMATES_TYPE = 'Estimate';
export const CUSTOMERS_TYPE = 'Customer';
export const EQUIPMENT_TYPE = 'Equipment';

export const appEnabledWithLaunchDarkly = (launchDarklyFlags, appInfo) => {
  const appDefinedInLaunchDarkly = isPresent(appInfo?.launchDarklyTag);
  if (!appDefinedInLaunchDarkly) return true;

  if (isPresent(launchDarklyFlags)) return launchDarklyFlags[appInfo?.launchDarklyTag];

  const hideByDefault = ['Job Inbox'].includes(appInfo.name);
  return !hideByDefault;
};

export const openProPhone = () => {
  const x = window.screen.width / 2 - VOICE_DEVICE_WIDTH / 2;
  const y = window.screen.height / 2 - VOICE_DEVICE_HEIGHT / 2;
  const windowFeatures = `scrollbars=no,width=${VOICE_DEVICE_WIDTH}px,height=${
    VOICE_DEVICE_HEIGHT + 1
  }px,top=${y},left=${x}`;
  const HCPPhoneWindow = window.open('', 'Housecall-Pro-Phone', windowFeatures);
  HCPPhoneWindow.opener = null;
  HCPPhoneWindow.location = '/app/voice';
};

export const getTheme = (isLargeTierPlan) => (isLargeTierPlan ? 'light' : 'dark');

export const getTotalBadgecount = (navigationTabs) =>
  navigationTabs.reduce((previousBadgeCount, currentBadgeCount) => previousBadgeCount + currentBadgeCount, 0);

export const getSearchResultsFilter = (data) => {
  const jobResults = [];
  const estimateResults = [];
  const customerResults = [];
  const equipmentResults = [];

  (data || []).forEach((item) => {
    if (item.object_type === JOBS_TYPE) {
      jobResults.push({
        ...item,
        redirectUrl: url.jobDetails.path(item.object_id),
      });
    }

    if (item.object_type === ESTIMATES_TYPE) {
      estimateResults.push({
        ...item,
        redirectUrl: url.estimatesDetails.path(item.object_id),
      });
    }

    if (item.object_type === CUSTOMERS_TYPE) {
      customerResults.push({
        ...item,
        redirectUrl: url.customerDetails.path(item.object_id),
      });
    }

    if (item.object_type === EQUIPMENT_TYPE) {
      equipmentResults.push({
        ...item,
        redirectUrl: url.equipmentDetails.path(item.object_id),
      });
    }
  });

  return {
    jobs: jobResults,
    estimates: estimateResults,
    customers: customerResults,
    equipment: equipmentResults,
  };
};

export const isEmptyResult = (results) => {
  const resultsKeys = Object.keys(results);
  return resultsKeys.every((key) => results[key].length === 0);
};
